export default function Mosaics2({ className, svgRef }) {
  return (
    <svg className={className} ref={svgRef} width="143" height="189" viewBox="0 0 143 189" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1072_757)">
      <path opacity="0.3" d="M105.371 72.9089L110.496 89.2633L94.1416 94.3883L89.0166 78.0339L105.371 72.9089Z" fill="#1078CA"/>
      <path d="M126.988 84.0944L132.113 100.449L115.759 105.574L110.634 89.2194L126.988 84.0944Z" fill="#1078CA"/>
      <path d="M111.57 34.8913L116.695 51.2457L100.341 56.3708L95.2158 40.0163L111.57 34.8913Z" fill="#1078CA"/>
      <path opacity="0.415" d="M104.48 127.377L109.605 143.731L93.251 148.856L88.126 132.502L104.48 127.377Z" fill="#1078CA"/>
      <path opacity="0.5" d="M89.0156 78.0339L94.1406 94.3883L77.7862 99.5133L72.6611 83.1589L89.0156 78.0339Z" fill="#1078CA"/>
      <path opacity="0.2" d="M94.1406 94.3883L99.2656 110.743L82.9112 115.868L77.7861 99.5134L94.1406 94.3883Z" fill="#1078CA"/>
      <path d="M78.7226 45.1852L83.8477 61.5397L67.4932 66.6647L62.3682 50.3103L78.7226 45.1852Z" fill="#1078CA"/>
      <path opacity="0.1" d="M66.6015 121.133L71.7266 137.487L55.3721 142.612L50.2471 126.258L66.6015 121.133Z" fill="#1078CA"/>
      <path opacity="0.3" d="M72.6601 83.1589L77.7852 99.5133L61.4307 104.638L56.3057 88.2839L72.6601 83.1589Z" fill="#1078CA"/>
      <path opacity="0.340681" d="M100.246 56.5544L105.371 72.9088L89.0166 78.0338L83.8916 61.6794L100.246 56.5544Z" fill="#1078CA"/>
      <path d="M148.512 95.4637L153.637 111.818L137.282 116.943L132.157 100.589L148.512 95.4637Z" fill="#1078CA"/>
      <path d="M133.094 46.2605L138.219 62.615L121.864 67.74L116.739 51.3856L133.094 46.2605Z" fill="#1078CA"/>
      </g>
      <defs>
      <clipPath id="clip0_1072_757">
      <rect width="150" height="150" fill="white" transform="matrix(-0.299033 -0.954243 -0.954243 0.299033 188.32 143.625)"/>
      </clipPath>
      </defs>
    </svg>
  );
}
